<template>
    <div id="wrapper" class="text-white">
        <div id="topSection">
                <h1>{{ logo }}</h1>
                <div>
                    <div class="pb-2">
                        <p class="font-weight-bold text-uppercase h4"> {{ channel }}</p>
                    </div>
                    <p class="lead">${{ price }}</p>
                    <p class="lead">${{ change }}</p>
                    <p class="lead">{{ changePercent}}%</p>
                </div>
        </div> 
        <div id="bottomSection" class="text-white">
            <p>Shares: {{shares}}</p>
        </div>
    
    </div>
</template>

<script>

export default {
    data() {
		return {
	
		}
	},
    props: ['channel', 'price', 'change', 'changePercent', 'subs', 'viewLikeRatio', 'logo', 'shares'],
	methods: {
        
	},
	components: {
        
	}
}
</script>

<style scoped>
    #wrapper {
        width: 300px;
        height: 400px;
        display: grid;
        grid-template-rows: 200px 200px;

    }
    #topSection {
        display: grid;
        grid-template-columns: 180px 120px;
    }
    #bottomSection {
        margin-top: 30px;
        display: grid;
         grid-template-columns:  33% 33% 33%
    }
    #stocklogo {
       height: auto;
       max-width: 125px;
    }
    #bg-dark1 {
        background-color: black !important;
    }

</style>